import Vue from 'vue'
import axios from 'axios'
import { API_URL } from '@/constants/config'
import store from '@/store'
import i18n from '@/libs/i18n'

const axiosIns = axios.create({
  baseURL: API_URL,
  headers: {
    common: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
      version: '2',
      'Content-Type': 'application/json',
      Accept: 'application/json',
      locale: 'en',
      'X-Requested-With': 'XMLHttpRequest',
      dashboard: true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Access-Control-Allow-Origin': '*',
      player_id: 'Dashboard',
      phase: 'd-2',
    },
  },
})

axiosIns.interceptors.request.use(config => {
  if (store.getters['branches/currentBranchId']) {
    // eslint-disable-next-line no-param-reassign
    config.headers['branch-id'] = store.getters['branches/currentBranchId']
  }
  // eslint-disable-next-line no-param-reassign
  config.headers.locale = i18n.locale
  // eslint-disable-next-line no-param-reassign
  config.headers['primary-account'] = store?.getters?.['auth/user']?.primaryAccount ?? false
  return config
})

axiosIns.interceptors.response.use(response => {
  if (response.data?.error) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject(response.data?.message)
  }
  return response
}, error => Promise.reject(error))

Vue.prototype.$http = axiosIns

export default axiosIns
